<template>
    <v-simple-table v-if="rows.length" dense>
        <thead>
            <tr>
                <th v-for="(col, i) in columns" :key="i" class="text-left">{{ col.name }}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(row, r) in rows" :key="r">
                <td v-for="(cell, c) in row" :key="c">{{ cell }}</td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
export default {
    name: 'TeamsportCombinedTable',

    props: {
        gameClassId: {
            type: Number
        },
        divisionIds: {
            type: Array,
            default: () => []
        }
    },

    data: () => ({
        columns: [],
        rows: []
    }),

    watch: {
        gameClassId: {
            immediate: true,
            handler() {
                if (!this.gameClassId) {
                    this.columns = [];
                    this.rows = [];
                    return;
                }
                this.fetch();
            }
        }
    },

    mounted() {
        // Keep the table current while results are reported/corrected. Scoped to
        // the selected steps' divisions so unrelated matches don't refetch.
        this.unsubscribe = this.$api.subscribe({type: 'teamsportmatch', callback: (match) => {
            if (match && this.divisionIds.indexOf(match.division_id) !== -1) {
                this.fetch();
            }
        }});
    },

    beforeDestroy() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    },

    methods: {
        fetch() {
            this.$api.get('/api/memberapi/teamsport/result/for_gameclass', {gameclass_id: this.gameClassId}).then((data) => {
                this.columns = data.columns || [];
                this.rows = data.rows || [];
            }).catch(() => {
                this.columns = [];
                this.rows = [];
            });
        }
    }
}
</script>
